import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-image-carousel',
  imports: [CommonModule],
  templateUrl: './image-carousel.component.html',
  styleUrl: './image-carousel.component.scss'
})
export class ImageCarouselComponent implements AfterViewInit {
  @Input() carouselItems: any;
  isAtStart = true;
  isAtEnd = false;
  @ViewChild('carouselWrapper', { static: true }) carouselWrapper!: ElementRef;
  @Output() selectProject = new EventEmitter<string>();

  constructor(private router: Router,) {}

  ngAfterViewInit(): void {
    this.checkScrollPosition();
    this.carouselWrapper.nativeElement.addEventListener('scroll', () => this.checkScrollPosition());
  }
  
  //Carousel Scrolling
  scrollLeft() {
    this.carouselWrapper.nativeElement.scrollBy({ left: -320, behavior: 'smooth' });
    this.checkScrollPosition();
  }

  scrollRight() {
    this.carouselWrapper.nativeElement.scrollBy({ left: 320, behavior: 'smooth' });
    this.checkScrollPosition();
  }

  checkScrollPosition() {
    const el = this.carouselWrapper.nativeElement;
    const maxScroll = el.scrollWidth - el.clientWidth;

    this.isAtStart = el.scrollLeft <= 0;
    this.isAtEnd = el.scrollLeft >= maxScroll - 1; // -1 for float precision
  }

  /**
   * A project page is only worth opening once it has a problem statement and a
   * solution — without them the detail page is empty, so the card stays inert.
   *
   * A project with no slug is inert for the same reason: the detail page is
   * addressed by slug, so there is no URL that would resolve to it.
   */
  isOpenable(item: any): boolean {
    return !!item?.slug
      && !!item?.problemStatement?.trim()
      && !!item?.solution?.trim();
  }

  goToProject(item: any) {
    if (!this.isOpenable(item)) {
      return;
    }
    // The slug, not the title: the title is localised, so a title-keyed URL
    // only resolved in the language it was built in.
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate(['/projects', item.slug]);
    });
  }
}
